import { render, staticRenderFns } from "./MessageEditorCarouselImage.vue?vue&type=template&id=8383dff6&scoped=true&"
import script from "./MessageEditorCarouselImage.vue?vue&type=script&lang=js&"
export * from "./MessageEditorCarouselImage.vue?vue&type=script&lang=js&"
import style0 from "./MessageEditorCarouselImage.vue?vue&type=style&index=0&id=8383dff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8383dff6",
  null
  
)

export default component.exports